import {useRef, useEffect} from 'react';
import {Modal} from '@cvent/carina/components/Modal';
import {LoadingSpinner} from '@cvent/carina/components/LoadingSpinner';

export interface LoadingModalProps {
  title: string;
  description: string;
}

export const LoadingModal = ({title, description}: LoadingModalProps) => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <Modal
      aria-label="loading modal"
      testID="loading-modal"
      isOpen
      portal
      format="sm"
    >
      <div className="my-4 mx-6">
        <h2
          ref={titleRef}
          className="mb-6 leading-header-4 text-header-5 outline-2 outline-offset-2 outline-transparent focus-visible:outline focus-visible:outline-primary-50"
          tabIndex={0}
        >
          {title}
        </h2>
        <p className="mb-6 text-body-small">{description}</p>
        <LoadingSpinner size="md" text="" className="mb-0" />
      </div>
    </Modal>
  );
};
